import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';
import HomePage from './pages/HomePage.vue';
import LoginPage from './pages/LoginPage.vue';
import RegisterPage from '@/pages/RegisterPage.vue';
import store from '@/store';
import { Actions } from '@/models/store.model';

const authenticateUser = async (
  to: RouteLocationNormalized,
  _: RouteLocationNormalized,
  next: (r?: any) => any,
): Promise<void> => {
  // TODO: do not check auth api again, unless the session is older than x (server sets cookie at 3 hours)
  const auth = await store.dispatch(Actions.GetAuth);

  if (auth.isUser) {
    next();
    return;
  }
  next({
    path: '/login',
    props: { redirect: to.fullPath },
  });
};

const authenticateAdmin = async (
  to: RouteLocationNormalized,
  _: RouteLocationNormalized,
  next: (r?: any) => any,
): Promise<void> => {
  // TODO: do not check auth api again, unless the session is older than x (server sets cookie at 3 hours)
  const auth = await store.dispatch(Actions.GetAuth);

  if (auth.isAdmin) {
    next();
    return;
  }
  next({
    path: '/login',
    props: { redirect: to.fullPath },
  });
};

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Bazaar 2025 Vrijeschool Mareland',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      title: 'Inloggen - Bazaar 2025',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    meta: {
      title: 'Registreren - Bazaar 2025',
    },
  },
  {
    path: '/programma',
    name: 'programma',
    component: () =>
      import(/* webpackChunkName: "programma" */ './pages/SchedulePage.vue'),
    meta: {
      title: 'Programma - Bazaar 2025',
    },
  },
  {
    path: '/plattegrond',
    name: 'plattegrond',
    component: () =>
      import(/* webpackChunkName: "plattegrond" */ './pages/MapPage.vue'),
    meta: {
      title: 'Plattegrond - Bazaar 2025',
    },
  },
  {
    path: '/berichten',
    name: 'berichten',
    component: () =>
      import(/* webpackChunkName: "berichten" */ './pages/MessagesPage.vue'),
    meta: {
      title: 'Berichten - Bazaar 2025',
    },
  },
  {
    path: '/veelgestelde-vragen',
    name: 'veelgestelde-vragen',
    component: () =>
      import(/* webpackChunkName: "veelgestelde" */ './pages/FAQPage.vue'),
    meta: {
      title: 'Veelgestelde vragen - Bazaar 2025',
    },
  },
  {
    path: '/activiteiten',
    name: 'activiteiten',
    component: () =>
      import(/* webpackChunkName: "activiteiten" */ './pages/ClassesPage.vue'),
    meta: {
      title: 'Activiteiten in de klassen - Bazaar 2025',
    },
  },
  {
    path: '/sponsors',
    name: 'sponsors',
    component: () =>
      import(/* webpackChunkName: "sponsors" */ './pages/SponsorsPage.vue'),
    meta: {
      title: 'Sponsors - Bazaar 2025',
    },
  },
  {
    path: '/rooster',
    name: 'rooster',
    component: () =>
      import(/* webpackChunkName: "rooster" */ './pages/RosterPage.vue'),
    meta: {
      title: 'Rooster - Bazaar 2025',
    },
  },
  {
    path: '/wiki/:slug?',
    name: 'wiki',
    component: () =>
      import(/* webpackChunkName: "wiki" */ './pages/WikiPage.vue'),
    meta: {
      title: 'Wiki - Bazaar',
    },
  },
  {
    path: '/wiki-tree',
    name: 'wiki-tree',
    component: () =>
      import(/* webpackChunkName: "wiki" */ './pages/WikiTreePage.vue'),
    meta: {
      title: 'Wiki Tree - Bazaar',
    },
  },
  {
    path: '/wiki-changes',
    name: 'wiki-changes',
    component: () =>
      import(/* webpackChunkName: "wiki" */ './pages/WikiChangesPage.vue'),
    meta: {
      title: 'Wiki Tree - Bazaar',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () =>
      import(/* webpackChunkName: "wiki" */ './pages/UsersPage.vue'),
    beforeEnter: authenticateAdmin,
    meta: {
      title: 'Users',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active', // active class for non-exact links.
  linkExactActiveClass: 'active active-exact',
  routes,
});

router.beforeEach((to, from, next) => {
  // Get the page title from the route meta data that we have defined
  // See further down below for how we setup this data
  const title: string = to.meta.title as string;
  // If the route has a title, set it as the page title of the document/page
  if (title) {
    document.title = title;
  }
  // Continue resolving the route
  next();
});

export default router;
